import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3fb4207e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "detail-container",
  ref: "scrollContainer"
}
const _hoisted_2 = { class: "title-wrapper" }
const _hoisted_3 = { class: "period" }
const _hoisted_4 = { class: "row-wrapper" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "title" }, "캠퍼스", -1 /* HOISTED */))
const _hoisted_6 = { class: "content" }
const _hoisted_7 = { class: "row-wrapper" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "title" }, "근무형태", -1 /* HOISTED */))
const _hoisted_9 = { class: "content" }
const _hoisted_10 = { class: "row-wrapper" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "title" }, "통상구분", -1 /* HOISTED */))
const _hoisted_12 = { class: "content" }
const _hoisted_13 = { class: "row-wrapper" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "title" }, "방향", -1 /* HOISTED */))
const _hoisted_15 = { class: "content" }
const _hoisted_16 = { class: "question-wrapper" }
const _hoisted_17 = { class: "title" }
const _hoisted_18 = { class: "content" }
const _hoisted_19 = {
  key: 0,
  class: "answer-wrapper"
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "피드백 내용", -1 /* HOISTED */))
const _hoisted_21 = { class: "content" }
const _hoisted_22 = { class: "row-wrapper result" }
const _hoisted_23 = { class: "left-wrapper" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "title" }, "검토결과 수신", -1 /* HOISTED */))
const _hoisted_25 = ["disabled"]
const _hoisted_26 = { class: "content" }
const _hoisted_27 = { class: "btns-wrapper" }
const _hoisted_28 = {
  key: 0,
  class: "right-wrapper"
}
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "empty-space" }, null, -1 /* HOISTED */))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode($setup["NewRouteStatusChip"], {
          statusCode: $props.applicationDetail.statusCode ?? '',
          statusName: $props.applicationDetail.statusName ?? ''
        }, null, 8 /* PROPS */, ["statusCode", "statusName"]),
        _createElementVNode("p", _hoisted_3, _toDisplayString($setup.usePeriodDisplayText), 1 /* TEXT */)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("p", _hoisted_6, _toDisplayString($props.applicationDetail.campusName), 1 /* TEXT */)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _createElementVNode("p", _hoisted_9, _toDisplayString($props.applicationDetail.workTimeName), 1 /* TEXT */)
      ]),
      _createElementVNode("div", _hoisted_10, [
        _hoisted_11,
        _createElementVNode("p", _hoisted_12, _toDisplayString($props.applicationDetail.talkLineWeekdayName), 1 /* TEXT */)
      ]),
      _createElementVNode("div", _hoisted_13, [
        _hoisted_14,
        _createElementVNode("p", _hoisted_15, _toDisplayString($props.applicationDetail.lineDirectionName), 1 /* TEXT */)
      ]),
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("p", _hoisted_17, [
          _createElementVNode("span", null, _toDisplayString($props.applicationDetail.title), 1 /* TEXT */),
          _createElementVNode("button", {
            type: "button",
            tabindex: "0",
            "aria-label": "지도에서 위치 보기",
            onClick: $setup.emitOnClickMap,
            style: { padding: 0 }
          }, [
            _createVNode($setup["InlineSvg"], {
              class: "map-icon",
              src: require('@/assets/icons/map.svg'),
              alt: "지도에서 위치 보기",
              "aria-hidden": "true"
            }, null, 8 /* PROPS */, ["src"])
          ])
        ]),
        _createElementVNode("div", _hoisted_18, _toDisplayString($props.applicationDetail.bodyText), 1 /* TEXT */)
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.applicationDetail.replies, (reply, index) => {
        return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
          (reply.displayYn)
            ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                _hoisted_20,
                _createElementVNode("div", _hoisted_21, _toDisplayString(reply.bodyText), 1 /* TEXT */)
              ]))
            : _createCommentVNode("v-if", true)
        ], 64 /* STABLE_FRAGMENT */))
      }), 128 /* KEYED_FRAGMENT */)),
      _createElementVNode("div", _hoisted_22, [
        _createElementVNode("div", _hoisted_23, [
          _hoisted_24,
          _createElementVNode("button", {
            class: "btn active-btn",
            type: "button",
            disabled: 
            $setup.isMyPost || $setup.isRecipient || !!$props.applicationDetail.replies.length
          ,
            onClick: $setup.emitOnClickReceiveResultBtn
          }, " 신청하기 ", 8 /* PROPS */, _hoisted_25)
        ]),
        _createElementVNode("p", _hoisted_26, _toDisplayString(`${$props.applicationDetail.receiverCount}명`), 1 /* TEXT */)
      ]),
      _createElementVNode("div", _hoisted_27, [
        ($setup.shouldShowEditAndDeleteButtons)
          ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
              _createCommentVNode(" <button class=\"btn default-btn\" @click=\"emitOnClickEditBtn\">\n          수정\n        </button> "),
              _createElementVNode("button", {
                type: "button",
                class: "btn default-btn",
                onClick: $setup.emitOnClickDeleteBtn
              }, " 삭제 ")
            ]))
          : _createCommentVNode("v-if", true)
      ]),
      _hoisted_29,
      _createVNode($setup["FooterButton"], {
        title: "목록",
        onOnClickFooterButton: $setup.goToNewRouteApplicationList
      })
    ], 512 /* NEED_PATCH */),
    ($setup.scrollContainer)
      ? (_openBlock(), _createBlock($setup["ScrollTopControl"], {
          key: 0,
          container: $setup.scrollContainer,
          style: { bottom: '80px' }
        }, null, 8 /* PROPS */, ["container"]))
      : _createCommentVNode("v-if", true)
  ], 64 /* STABLE_FRAGMENT */))
}